import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=540f28e9&scoped=true&"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=540f28e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f28e9",
  null
  
)

export default component.exports